import { Component, Input, SimpleChanges } from '@angular/core';
import { debounce } from 'rxjs';
@Component({
    selector: 'app-summary-card',
    templateUrl: './summary-card.component.html',
    styleUrl: './summary-card.component.scss',
    standalone: false,
})
export class SummaryCardComponent {
  @Input() title: string = '';
  @Input() currentValue: number = 0;
  @Input() previousValue: number = 0;
  @Input() percent: any;
  @Input() dynamics: 'positive' | 'negative' | 'neutral' = 'positive';
  @Input() isLoading: boolean = false;
  @Input() dollar: string = ''

 displayPercent: string | number = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['percent']) {
      this.formatPercent();
    }
  }

  formatPercent() {
    if (this.percent === 'Infinity' || this.percent === Infinity) {
      this.displayPercent = '∞';
    } else if (isNaN(this.percent) || this.percent === null || this.percent === undefined) {
      this.displayPercent = '—';
    } else {
      this.displayPercent = Math.abs(+this.percent).toFixed(1); 
    }
  }
}
